
export const ADMINAMCCUSTOMERLIST_GET="ADMINAMCCUSTOMERLIST_GET"
export const ADMINAMCCUSTOMERLIST_SUCCESS="ADMINAMCCUSTOMERLIST_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

